/** File is auto-generated by TypeWriter, a plug-in for Visual Studio. Modifications will be overridden when the template is rendered */


interface AddressDTO {
  addressLine1: string;
  addressLine2: string;
  addressLine3: string;
  city: string;
  /** State or province, depending on Country */
  region: string;
  country: string;
  postalCode: string;
}
const AddressDTO = {
  create: (initValues?: Partial<AddressDTO> | null): AddressDTO => {
    const defaults: AddressDTO = {
      addressLine1: "",
      addressLine2: "",
      addressLine3: "",
      city: "",
      region: "",
      country: "",
      postalCode: "",
    };
    const fixedValues: Partial<AddressDTO> = initValues != null
      ? {
      }
      : {};
    return { ...defaults, ...initValues, ...fixedValues };
  }
};

export default AddressDTO;
